'use strict';/* global define:false, console:false */define('helen/ui/charts/responsive-chart',['angular'],function(ng){'use strict';// TODO: remove?
function directive($timeout,$parse){return{restrict:'A',link:function link(scope,element,attrs){// // jshint latedef:false
// var timeout;
// window.onresize = resize;
// var getter = $parse( attrs.responsiveChart || '[data]' );
// scope.$on( '$destroy',  scope.$watch( watch, respond ) );
// function resize() {
//   if ( timeout ) {
//     $timeout.cancel( timeout );
//   }
//   timeout = $timeout( function () {
//     scope.$apply();
//   }, 75 );
// }
// function watch() {
//   return element[ 0 ].width;
// }
// function respond() {
//   var s = element.isolateScope() || scope;
//   if ( ! ng.isFunction( s.render ) ) {
//     return;
//   }
//   s.render.apply( s, getter( s ) );
// }
}};}directive.$inject=['$timeout','$parse'];return directive;});
